/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/* eslint-disable @repo/internal/react/require-jsdoc */
import React, { type ReactNode } from 'react';

import { css, jsx } from '@compiled/react';

const absolutePositionStyles = css({ position: 'absolute' });
const relativePositionStyles = css({ position: 'relative' });

export const AbsolutePosition: ({
	top,
	right,
	bottom,
	left,
	children,
}: {
	top?: number | string;
	right?: number | string;
	bottom?: number | string;
	left?: number | string;
	children: ReactNode;
}) => JSX.Element = ({
	top,
	right,
	bottom,
	left,
	children,
}: {
	top?: number | string;
	right?: number | string;
	bottom?: number | string;
	left?: number | string;
	children: ReactNode;
}) => {
	return (
		<div
			css={absolutePositionStyles}
			style={{
				top,
				right,
				bottom,
				left,
			}}
		>
			{children}
		</div>
	);
};

export const RelativePosition: React.ForwardRefExoticComponent<
	{
		top?: number | string;
		right?: number | string;
		bottom?: number | string;
		left?: number | string;
		children: ReactNode;
	} & React.RefAttributes<HTMLDivElement>
> = React.forwardRef<
	HTMLDivElement,
	{
		top?: number | string;
		right?: number | string;
		bottom?: number | string;
		left?: number | string;
		children: ReactNode;
	}
>(({ top, right, bottom, left, children }, ref) => {
	return (
		<div
			ref={ref}
			css={relativePositionStyles}
			style={{
				top,
				right,
				bottom,
				left,
			}}
		>
			{children}
		</div>
	);
});
